<template>                
    <div class="accordion scorecard-accordion" role="tablist">  <!-- everything should be wrapped inside something with role="tablist" for a11y -->
        <div 
            v-for="(sc, idx) in scorecards"
            :key="sc.unique_id"
            class="supplier-scorecard mb-2 border rounded-lg overflow-hidden"
            :class="openCollapseUniqueId === sc.unique_id ? 'shadow' : ''"
        >
            <div class="" role="tab">  <!-- should have role="tab" on each trigger element's container for a11y-->
                <b-button block v-b-toggle="'accordion-' + sc.unique_id" variant="zone-secondary" class="d-flex px-4 justify-content-between align-items-center">
                    <div>
                        <h5 class="mb-0">{{ getTitle(sc) }}</h5>
                    </div>
                    <div>
                        <span class="text-dark font-size-120 font-weight-bold mr-2">{{ sc.final_points }}</span>
                        <span class="text-muted text-uppercase font-weight-bold">{{ systemData.points_name }}</span>
                    </div>
                </b-button>
            </div>
            <b-collapse 
                :id="'accordion-' + sc.unique_id" 
                :visible="idx === 0" 
                accordion="scorecard-accordion" 
                role="tabpanel"
                @shown="handleCollapseShow(sc.unique_id)"
                @hide="handleCollapseHide(sc.unique_id)"
            >  <!-- add role="tabpanel" for a11y -->
                <div class="p-4 bg-gray-50">
                    <div class="row">
                        <div class="col-6 col-md-3 col-lg-3">
                            <div class="mb-1 text-primary-darker text-uppercase font-size-80 font-weight-700">
                                {{ systemData.name }}
                            </div>
                            <div class="font-weight-bold font-size-110 mb-3">
                                {{ sc.vendor.name }}
                            </div>
                            <div class="mb-1 text-muted text-uppercase font-size-80 font-weight-400">For Period:</div>
                            <div class="font-weight-bold font-size-110 text-left">{{ sc.name }}</div>
                        </div>
                        <div class="col-6 col-md-3 col-lg-2">
                            <div v-if="sc.starting_points" key="hasStartingPoints">
                                <!-- maybe should call this 'max_points' instead?  you might start at 0 and still want to show a knob if there is a known max -->
                                <Knob 
                                    :value="sc.final_points" 
                                    readonly 
                                    :min="0" 
                                    :max="sc.starting_points"
                                    valueColor="blue"
                                    textColor="#000000"
                                    class="text-center"
                                ></Knob>
                                <div class="text-muted text-center">of {{sc.starting_points}} total</div>
                            </div>
                            <div v-else key="noStartingPoints" class="">
                                <div class="text-muted text-center font-size-300 font-weight-bold">{{ sc.final_points }}</div>
                                <div class="text-muted text-center text-uppercase">{{ systemData.points_name }}</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-7">
                            <scorecard-item-list
                                :systemData="systemData"
                                :items="sc.items"
                                class="h-100 w-100"
                            ></scorecard-item-list>
                        </div>
                    </div>
                </div>
            </b-collapse>
        </div>
    </div>
            
</template>

<script>
import { errorHandling, currentUserInfoMixin } from '../../js/custom-vue-mixins';
import Knob from 'primevue/knob';
import ScorecardItemList from './ScorecardItemList.vue';
import get from 'lodash/get';


export default {
    name: 'ScorecardAccordion',
    components: {
        Knob,
        ScorecardItemList,
    },
    mixins: [
        errorHandling,
        currentUserInfoMixin,
    ],
    props: {
        systemData: { // object of the ScorecardSystem data
            type: Object,
            required: true,
        },
        scorecards: {
            type: Array,
            required: true,
        },
        titleProperty: {  // property / dotted.path on Scorecard object that we display in title of each accordion button
            type: String,
            default: 'name',  // but 'vendor.name' makes more sense for single period, multiple vendors
        } ,
        // add something about sort order?  or handle that in parent... yes
    },
    data: function() {
        return {
            errorMsg: 'Error',
            error: false,
            // 
            openCollapseUniqueId: '',  // unique_id of the currently showing collapse in accordion
        };
    },
    computed: {
        hasSystemData() {
            return !!this.systemData;
        },
        hasScorecards() {
            return !!this.scorecards?.length;
        },
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage
        getTitle(scorecard) {
            return get(scorecard, this.titleProperty);
        },
        handleCollapseShow(uniqueId) {
            this.openCollapseUniqueId = uniqueId;
        },
        handleCollapseHide(uniqueId) {
            if (this.openCollapseUniqueId === uniqueId) {
                this.openCollapseUniqueId = '';
                // if you closed it and no new one opened, clear it from being the open one
            }
        }
    }
}
</script>

<style lang="scss">

.supplier-scorecard {
    .p-knob-text {
        font-weight: 700;
    }
}

</style>